module.exports = __webpack_public_path__ + "static/media/michel.35c60ecc.jpg";